import React, { useState } from 'react';
import './authLogin.css';
import { useNavigate } from 'react-router-dom';
import { login } from '../../services/authService'; // Assuming you'll create this service
import { useAuth } from '../../contexts/AuthContext';

function Login() {
  const [identity, setIdentity] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const { login: authLogin } = useAuth(); // Rename to avoid conflict

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const userData = await login({ identity, password });
      authLogin(userData); // Update AuthContext
      navigate('/dashboard');
    } catch (error) {
      console.error('Login failed:', error);
      // Handle error
    }
  };

  return (
        <form onSubmit={handleSubmit} className="login-form">
		   <h2 className="login-header">Login</h2>
            <input
                type="text"
                placeholder="Username or Email"
                value={identity}
                onChange={(e) => setIdentity(e.target.value)}
            />
            <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
            />
            <button type="submit">Login</button>
        </form>
    );
}

export default Login;